const color = {
    white: "#FFF",
    gray: "#D6D6D6",
    green: "#80BB3A",
    blueCalculator: "#707AB9",
    calculatorBackColor: "#4F5683"
  };
  
  export default color;